
// //
// // ================================
// // 📌 HorarioEstudianteAdmin.jsx
// // ================================
// import React, { useEffect, useState, useCallback } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/HorarioEstudiante.css";

// const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

// export default function HorarioEstudianteAdmin() {
//   const { token, user } = useAuth();
//   const headers = { Authorization: `Bearer ${token}` };

//   /* ===============================
//      🔹 ESTADOS
//   =============================== */
//   const [sedes, setSedes] = useState([]);
//   const [sedeId, setSedeId] = useState("");

//   const [grupos, setGrupos] = useState([]);
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");

//   const [horario, setHorario] = useState([]);

//   const [profesores, setProfesores] = useState([]);
//   const [profesorId, setProfesorId] = useState("");
//   const [materias, setMaterias] = useState([]);

//   const [nuevo, setNuevo] = useState({
//     asignacion_id: "",
//     dia: "",
//     hora_inicio: "",
//     hora_fin: "",
//     aula: ""
//   });

//   /* ===============================
//      🏫 SEDES
//   =============================== */
//   useEffect(() => {
//     if (!token) return;

//     axios.get(`${API}/sedes`, { headers })
//       .then(res => setSedes(res.data))
//       .catch(err => console.error("❌ Error sedes:", err));
//   }, [token]);

//   /* ===============================
//      📚 GRUPOS
//   =============================== */
//   useEffect(() => {
//     if (!sedeId) return;

//     setGrado("");
//     setGrupo("");
//     setGrupos([]);
//     setProfesores([]);
//     setProfesorId("");
//     setMaterias([]);
//     setHorario([]);

//     axios
//       .get(`${API}/horario-estudiante/grupos/${sedeId}`, { headers })
//       .then(res => setGrupos(res.data))
//       .catch(err => console.error("❌ Error grupos:", err));
//   }, [sedeId]);

//   /* ===============================
//      📅 CARGAR HORARIO
//   =============================== */
//   const cargarHorario = useCallback(async () => {
//     try {
//       if (!sedeId || !grado || !grupo) return;

//       const res = await axios.get(
//         `${API}/horario-estudiante/${sedeId}/${grado}/${grupo}`,
//         { headers }
//       );

//       setHorario(res.data);
//     } catch (error) {
//       console.error("❌ Error cargar horario:", error);
//     }
//   }, [sedeId, grado, grupo, token]);

//   /* ===============================
//      👨‍🏫 PROFESORES + HORARIO
//   =============================== */
//   useEffect(() => {
//     if (!sedeId || !grado || !grupo) return;

//     setProfesorId("");
//     setMaterias([]);

//     axios
//       .get(`${API}/horario-estudiante/profesores/${sedeId}`, { headers })
//       .then(res => setProfesores(res.data))
//       .catch(err => console.error("❌ Error profesores:", err));

//     cargarHorario();
//   }, [sedeId, grado, grupo, cargarHorario]);

//   /* ===============================
//      📘 MATERIAS
//   =============================== */
//   useEffect(() => {
//     if (!profesorId || !grado || !grupo) return;

//     axios
//       .get(
//         `${API}/horario-estudiante/materias-profesor/${profesorId}/${grado}/${grupo}`,
//         { headers }
//       )
//       .then(res => setMaterias(res.data))
//       .catch(err => console.error("❌ Error materias:", err));
//   }, [profesorId, grado, grupo]);

//   /* ===============================
//      ➕ CREAR HORARIO
//   =============================== */
//   const crearHorario = async () => {
//     if (!nuevo.asignacion_id || !nuevo.dia || !nuevo.hora_inicio || !nuevo.hora_fin) {
//       return alert("Completa todos los campos");
//     }

//     if (nuevo.hora_inicio >= nuevo.hora_fin) {
//       return alert("Hora inicio debe ser menor que hora fin");
//     }

//     try {
//       await axios.post(
//         `${API}/horario-estudiante`,
//         {
//           asignacion_id: nuevo.asignacion_id,
//           dia: nuevo.dia,
//           hora_inicio: nuevo.hora_inicio,
//           hora_fin: nuevo.hora_fin,
//           aula: nuevo.aula,
//           sede_id: sedeId === "tenant" ? null : sedeId,
//           grado,
//           grupo
//         },
//         { headers }
//       );

//       setNuevo({
//         asignacion_id: "",
//         dia: "",
//         hora_inicio: "",
//         hora_fin: "",
//         aula: ""
//       });

//       await cargarHorario();

//     } catch (error) {
//       console.error("❌ Error crear horario:", error.response?.data || error.message);
//       alert("Error al crear horario");
//     }
//   };

//   /* ===============================
//      🗑️ ELIMINAR HORARIO (FIX 🔥)
//   =============================== */
//   const eliminarHorario = async (id) => {
//     if (!id) return;

//     const confirmar = window.confirm("¿Eliminar este horario?");
//     if (!confirmar) return;

//     try {
//       await axios.delete(`${API}/horario-estudiante/${id}`, { headers });

//       // 🔥 actualización inmediata sin esperar reload
//       setHorario(prev => prev.filter(h => h.id !== id));

//     } catch (error) {
//       console.error("❌ Error eliminando:", error.response?.data || error.message);
//       alert("Error al eliminar horario");
//     }
//   };

//   /* ===============================
//      🚀 PUBLICAR
//   =============================== */
//   const publicarHorario = async () => {
//     if (!sedeId || !grado || !grupo) {
//       return alert("Selecciona sede, grado y grupo");
//     }

//     if (!window.confirm("¿Publicar horario?")) return;

//     try {
//       await axios.post(
//         `${API}/horario-estudiante/publicar/${sedeId}/${grado}/${grupo}`,
//         {},
//         { headers }
//       );

//       alert("Horario publicado");
//     } catch (error) {
//       console.error("❌ Error publicar:", error);
//       alert("Error al publicar");
//     }
//   };

//   /* ===============================
//      🔐 ROLES
//   =============================== */
//   if (!["rector", "coordinador", "secretaria"].includes(user?.role)) {
//     return <h3>No autorizado</h3>;
//   }

//   /* ===============================
//      🧠 NORMALIZACIÓN
//   =============================== */
//   const grados = [...new Set(grupos.map(g => String(g.grado)))];
//   const gruposFiltrados = grupos.filter(g => String(g.grado) === String(grado));

//   /* ===============================
//      🖥️ UI
//   =============================== */
//   return (
//     <div className="horario-estudiante-container">
//       <h2>📅 Horario Estudiantil</h2>

//       <select value={sedeId} onChange={e => setSedeId(e.target.value)}>
//         <option value="">Seleccione sede</option>

//         <option value="tenant">
//           🏫 {user?.tenant_nombre || "Colegio"} (Principal)
//         </option>

//         {sedes.map(s => (
//           <option key={s.id} value={s.id}>
//             {user?.tenant_nombre || "sedes"} - {s.nombre}
//           </option>
//         ))}
//       </select>

//       {sedeId && (
//         <>
//           <div className="filtros">
//             <select value={grado} onChange={e => { setGrado(e.target.value); setGrupo(""); }}>
//               <option value="">Grado</option>
//               {grados.map(g => <option key={g} value={g}>{g}</option>)}
//             </select>

//             <select value={grupo} onChange={e => setGrupo(e.target.value)} disabled={!grado}>
//               <option value="">Grupo</option>
//               {gruposFiltrados.map((g, i) => (
//                 <option key={i} value={g.grupo}>{g.grupo}</option>
//               ))}
//             </select>
//           </div>

//           {grado && grupo && (
//             <>
//               <button onClick={publicarHorario}>📤 Publicar</button>

//               <h3>Agregar clase</h3>

//               <div className="filtros">
//                 <select value={profesorId} onChange={e => setProfesorId(e.target.value)}>
//                   <option value="">Profesor</option>
//                   {profesores.map(p => (
//                     <option key={p.id} value={p.id}>{p.profesor}</option>
//                   ))}
//                 </select>

//                 <select
//                   value={nuevo.asignacion_id}
//                   onChange={e => setNuevo({ ...nuevo, asignacion_id: e.target.value })}
//                   disabled={!profesorId}
//                 >
//                   <option value="">Materia</option>
//                   {materias.map(m => (
//                     <option key={m.asignacion_id} value={m.asignacion_id}>
//                       {m.materia}
//                     </option>
//                   ))}
//                 </select>

//                 <select value={nuevo.dia} onChange={e => setNuevo({ ...nuevo, dia: e.target.value })}>
//                   <option value="">Día</option>
//                   {["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"].map(d => (
//                     <option key={d} value={d}>{d}</option>
//                   ))}
//                 </select>

//                 <input type="time" value={nuevo.hora_inicio}
//                   onChange={e => setNuevo({ ...nuevo, hora_inicio: e.target.value })} />

//                 <input type="time" value={nuevo.hora_fin}
//                   onChange={e => setNuevo({ ...nuevo, hora_fin: e.target.value })} />

//                 <input placeholder="Aula"
//                   value={nuevo.aula}
//                   onChange={e => setNuevo({ ...nuevo, aula: e.target.value })} />

//                 <button onClick={crearHorario}>Agregar</button>
//               </div>

//               <table className="tabla-horario">
//                 <thead>
//                   <tr>
//                     <th>Día</th>
//                     <th>Inicio</th>
//                     <th>Fin</th>
//                     <th>Materia</th>
//                     <th>Profesor</th>
//                     <th>Aula</th>
//                     <th></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {horario.map(h => (
//                     <tr key={h.id}>
//                       <td>{h.dia}</td>
//                       <td>{h.hora_inicio}</td>
//                       <td>{h.hora_fin}</td>
//                       <td>{h.materia}</td>
//                       <td>{h.profesor}</td>
//                       <td>{h.aula}</td>
//                       <td>
//                         <button onClick={() => eliminarHorario(h.id)}>❌</button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </>
//           )}
//         </>
//       )}
//     </div>
//   );
// }


//

import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API } from "../config"; // ✅ Importación centralizada
import "../../style/HorarioEstudiante.css";

export default function HorarioEstudianteAdmin() {
  const { token, user } = useAuth();
  
  // Memorizamos los headers para que no cambien en cada render
  const headers = useMemo(() => ({
    Authorization: `Bearer ${token}`
  }), [token]);

  /* ===============================
      🔹 ESTADOS
  =============================== */
  const [sedes, setSedes] = useState([]);
  const [sedeId, setSedeId] = useState("");

  const [grupos, setGrupos] = useState([]);
  const [grado, setGrado] = useState("");
  const [grupo, setGrupo] = useState("");

  const [horario, setHorario] = useState([]);

  const [profesores, setProfesores] = useState([]);
  const [profesorId, setProfesorId] = useState("");
  const [materias, setMaterias] = useState([]);

  const [nuevo, setNuevo] = useState({
    asignacion_id: "",
    dia: "",
    hora_inicio: "",
    hora_fin: "",
    aula: ""
  });

  /* ===============================
      🏫 SEDES
  =============================== */
  useEffect(() => {
    if (!token) return;

    axios.get(`${API}/sedes`, { headers })
      .then(res => setSedes(res.data))
      .catch(err => console.error("❌ Error sedes:", err));
  }, [token, headers]);

  /* ===============================
      📚 GRUPOS
  =============================== */
  useEffect(() => {
    if (!sedeId) return;

    setGrado("");
    setGrupo("");
    setGrupos([]);
    setProfesores([]);
    setProfesorId("");
    setMaterias([]);
    setHorario([]);

    axios
      .get(`${API}/horario-estudiante/grupos/${sedeId}`, { headers })
      .then(res => setGrupos(res.data))
      .catch(err => console.error("❌ Error grupos:", err));
  }, [sedeId, headers]);

  /* ===============================
      📅 CARGAR HORARIO
  =============================== */
  const cargarHorario = useCallback(async () => {
    if (!sedeId || !grado || !grupo) return;
    try {
      const res = await axios.get(
        `${API}/horario-estudiante/${sedeId}/${grado}/${grupo}`,
        { headers }
      );
      setHorario(res.data);
    } catch (error) {
      console.error("❌ Error cargar horario:", error);
    }
  }, [sedeId, grado, grupo, headers]);

  /* ===============================
      👨‍🏫 PROFESORES
  =============================== */
  useEffect(() => {
    if (!sedeId || !grado || !grupo) return;

    setProfesorId("");
    setMaterias([]);

    axios
      .get(`${API}/horario-estudiante/profesores/${sedeId}`, { headers })
      .then(res => setProfesores(res.data))
      .catch(err => console.error("❌ Error profesores:", err));

    cargarHorario();
  }, [sedeId, grado, grupo, cargarHorario, headers]);

  /* ===============================
      📘 MATERIAS
  =============================== */
  useEffect(() => {
    if (!profesorId || !grado || !grupo) return;

    axios
      .get(
        `${API}/horario-estudiante/materias-profesor/${profesorId}/${grado}/${grupo}`,
        { headers }
      )
      .then(res => setMaterias(res.data))
      .catch(err => console.error("❌ Error materias:", err));
  }, [profesorId, grado, grupo, headers]);

  /* ===============================
      ➕ CREAR HORARIO
  =============================== */
  const crearHorario = async () => {
    const { asignacion_id, dia, hora_inicio, hora_fin, aula } = nuevo;

    if (!asignacion_id || !dia || !hora_inicio || !hora_fin) {
      return alert("Completa todos los campos obligatorios");
    }

    if (hora_inicio >= hora_fin) {
      return alert("La hora de inicio debe ser anterior a la hora de fin");
    }

    try {
      await axios.post(
        `${API}/horario-estudiante`,
        {
          asignacion_id,
          dia,
          hora_inicio,
          hora_fin,
          aula,
          sede_id: sedeId === "tenant" ? null : sedeId,
          grado,
          grupo
        },
        { headers }
      );

      setNuevo({
        asignacion_id: "",
        dia: "",
        hora_inicio: "",
        hora_fin: "",
        aula: ""
      });

      await cargarHorario();
    } catch (error) {
      console.error("❌ Error crear horario:", error.response?.data || error.message);
      alert(error.response?.data?.error || "Error al crear horario");
    }
  };

  /* ===============================
      🗑️ ELIMINAR HORARIO
  =============================== */
  const eliminarHorario = async (id) => {
    if (!id || !window.confirm("¿Estás seguro de eliminar este bloque de horario?")) return;

    try {
      await axios.delete(`${API}/horario-estudiante/${id}`, { headers });
      setHorario(prev => prev.filter(h => h.id !== id));
    } catch (error) {
      console.error("❌ Error eliminando:", error);
      alert("No se pudo eliminar el horario");
    }
  };

  /* ===============================
      🚀 PUBLICAR
  =============================== */
  const publicarHorario = async () => {
    if (!sedeId || !grado || !grupo) return alert("Selección incompleta");
    if (!window.confirm("¿Publicar este horario para que sea visible por estudiantes?")) return;

    try {
      await axios.post(`${API}/horario-estudiante/publicar/${sedeId}/${grado}/${grupo}`, {}, { headers });
      alert("✅ Horario publicado exitosamente");
    } catch (error) {
      console.error("❌ Error publicar:", error);
      alert("Error al publicar");
    }
  };

  /* ===============================
      🔐 SEGURIDAD Y NORMALIZACIÓN
  =============================== */
  const allowedRoles = ["rector", "coordinador", "secretaria"];
  if (!allowedRoles.includes(user?.role)) {
    return <h3 className="no-auth">Acceso restringido</h3>;
  }

  const gradosList = [...new Set(grupos.map(g => String(g.grado)))].sort((a, b) => a - b);
  const gruposFiltrados = grupos.filter(g => String(g.grado) === String(grado));

  /* ===============================
      🖥️ RENDER
  =============================== */
  return (
    <div className="horario-estudiante-container">
      <h2>📅 Configuración de Horario</h2>

      <div className="selector-sede">
        <select value={sedeId} onChange={e => setSedeId(e.target.value)}>
          <option value="">Seleccione sede...</option>
          <option value="tenant">🏫 Sede Principal</option>
          {sedes.map(s => (
            <option key={s.id} value={s.id}>📍 {s.nombre}</option>
          ))}
        </select>
      </div>

      {sedeId && (
        <div className="fade-in">
          <div className="filtros-principales">
            <select value={grado} onChange={e => { setGrado(e.target.value); setGrupo(""); }}>
              <option value="">Grado</option>
              {gradosList.map(g => <option key={g} value={g}>{g}°</option>)}
            </select>

            <select value={grupo} onChange={e => setGrupo(e.target.value)} disabled={!grado}>
              <option value="">Grupo</option>
              {gruposFiltrados.map((g, i) => (
                <option key={i} value={g.grupo}>{g.grupo}</option>
              ))}
            </select>
            
            {/* {grado && grupo && (
              // <button className="btn-publicar" onClick={publicarHorario}>📤 Publicar Horario</button>
            )} */}
          </div>

          {grado && grupo && (
            <div className="seccion-edicion">
              <div className="card-agregar">
                <h3>Añadir Nueva Clase</h3>
                <div className="grid-form">
                  <select value={profesorId} onChange={e => setProfesorId(e.target.value)}>
                    <option value="">Seleccione Profesor</option>
                    {profesores.map(p => (
                      <option key={p.id} value={p.id}>{p.profesor}</option>
                    ))}
                  </select>

                  <select
                    value={nuevo.asignacion_id}
                    onChange={e => setNuevo({ ...nuevo, asignacion_id: e.target.value })}
                    disabled={!profesorId}
                  >
                    <option value="">Seleccione Materia</option>
                    {materias.map(m => (
                      <option key={m.asignacion_id} value={m.asignacion_id}>{m.materia}</option>
                    ))}
                  </select>

                  <select value={nuevo.dia} onChange={e => setNuevo({ ...nuevo, dia: e.target.value })}>
                    <option value="">Día de la semana</option>
                    {["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"].map(d => (
                      <option key={d} value={d}>{d}</option>
                    ))}
                  </select>

                  <div className="input-horas">
                    <input type="time" value={nuevo.hora_inicio}
                      onChange={e => setNuevo({ ...nuevo, hora_inicio: e.target.value })} title="Hora Inicio" />
                    <input type="time" value={nuevo.hora_fin}
                      onChange={e => setNuevo({ ...nuevo, hora_fin: e.target.value })} title="Hora Fin" />
                  </div>

                  <input placeholder="Aula (Opcional)"
                    value={nuevo.aula}
                    onChange={e => setNuevo({ ...nuevo, aula: e.target.value })} />

                  <button className="btn-add" onClick={crearHorario}>+ Agregar</button>
                </div>
              </div>

              <div className="tabla-responsiva">
                <table className="tabla-horario">
                  <thead>
                    <tr>
                      <th>Día</th>
                      <th>Horario</th>
                      <th>Materia</th>
                      <th>Profesor</th>
                      <th>Aula</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {horario.length > 0 ? (
                      horario.map(h => (
                        <tr key={h.id}>
                          <td className="bold">{h.dia}</td>
                          <td><small>{h.hora_inicio} - {h.hora_fin}</small></td>
                          <td>{h.materia}</td>
                          <td>{h.profesor}</td>
                          <td>{h.aula || "N/A"}</td>
                          <td>
                            <button className="btn-del" onClick={() => eliminarHorario(h.id)}>🗑️</button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">No hay clases programadas</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}